import { AfterViewInit, Component, ElementRef, ViewChild, input } from '@angular/core';

@Component({
  selector: 'cam-calendar-bucket-item',
  standalone: true,
  templateUrl: './bucket-item.component.html',
  styleUrl: './bucket-item.component.scss',
})
export class CamBucketItemComponent implements AfterViewInit {
  data = input.required<unknown>();

  @ViewChild('itemElement', { static: true })
  itemElement!: ElementRef<HTMLDivElement>;

  ngAfterViewInit() {
    const data = this.data();
    if (data) {
      this.itemElement.nativeElement.dataset['brut'] = JSON.stringify(data);
    }
  }
}
